// ** Initial State
const initialState = {
  // List
  data: [],
  total: 1,
  params: {},
  allData: [],
  notifySuccessDeleteEncounterMedicine: null,
  notifyFailedDeleteEncounterMedicine: null,
  currentMedicine: null,
  // Medicine types, classifications, dosage forms
  types: [],
  classifications: [],
  dosageForms: [],
  // Create medicine
  loading: {
    createMedicine: false,
    getTypes: false,
    getClassifications: false,
    getDosageForms: false
  },
  success: {
    createMedicine: false
  },
  errors: {
    createMedicine: null
  }
}

const MedicineReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_ENCOUNTER_MEDICINES':
      return Object.assign({}, state, {
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params
      })
    case 'SUCCESS_DELETE_ENCOUNTER_MEDICINE':
      return Object.assign({}, state, { notifySuccessDeleteEncounterMedicine: true })
    case 'FAILED_DELETE_ENCOUNTER_MEDICINE':
      return Object.assign({}, state, { notifyFailedDeleteEncounterMedicine: true })
    case 'GET_DETAIL_DATA_MEDICINE':
      return Object.assign({}, state, { currentMedicine: action.currentMedicine, notifyFailedGetDetailMedicine: null })
    case 'FAILED_GET_DETAIL_DATA_MEDICINE':
      return Object.assign({}, state, { currentMedicine: null, notifyFailedGetDetailMedicine: true })
    case 'RESET_DELETE_ENCOUNTER_MEDICINE':
      return {
        ...state, 
        notifySuccessDeleteEncounterMedicine: null,
        notifyFailedDeleteEncounterMedicine: null
      }  
    case 'GET_DETAIL_DATA_MEDICINE':
      return {
        ...state,
        medicineDetail: action.medicineDetail,
        getDetailMedicineError: null
      }
    case 'FAILED_GET_DETAIL_DATA_MEDICINE':
      return {
        ...state,
        medicineDetail: null,
        getDetailMedicineError: true
      }
    case 'CREATE_MEDICINE_REQUEST':
      return {
        ...state,
        loading: { ...state.loading, createMedicine: true },
        errors: { ...state.errors, createMedicine: null }
      }
    case 'CREATE_MEDICINE_SUCCESS':
      return {
        ...state,
        loading: { ...state.loading, createMedicine: false },
        success: { ...state.success, createMedicine: true },
        errors: { ...state.errors, createMedicine: null }
      }
    case 'CREATE_MEDICINE_FAILURE':
      return {
        ...state,
        loading: { ...state.loading, createMedicine: false },
        success: { ...state.success, createMedicine: false },
        errors: { ...state.errors, createMedicine: action.errorMessage }
      }
    case 'GET_MEDICINE_TYPES_SUCCESS':
      return {
        ...state,
        types: action.types || [],
        loading: { ...state.loading, getTypes: false }
      }
    case 'GET_MEDICINE_TYPES_FAILURE':
      return {
        ...state,
        types: [],
        loading: { ...state.loading, getTypes: false }
      }
    case 'GET_MEDICINE_CLASSIFICATIONS_SUCCESS':
      return {
        ...state,
        classifications: action.classifications || [],
        loading: { ...state.loading, getClassifications: false }
      }
    case 'GET_MEDICINE_CLASSIFICATIONS_FAILURE':
      return {
        ...state,
        classifications: [],
        loading: { ...state.loading, getClassifications: false }
      }
    case 'GET_DOSAGE_FORMS_SUCCESS':
      return {
        ...state,
        dosageForms: action.dosageForms || [],
        loading: { ...state.loading, getDosageForms: false }
      }
    case 'GET_DOSAGE_FORMS_FAILURE':
      return {
        ...state,
        dosageForms: [],
        loading: { ...state.loading, getDosageForms: false }
      }
    case 'CLEAR_MEDICINE_ERRORS':
      return {
        ...state,
        errors: {
          createMedicine: null
        }
      }
    case 'CLEAR_MEDICINE_SUCCESS':
      return {
        ...state,
        success: {
          createMedicine: false
        }
      }
    default:
      return state
  }
}

export default MedicineReducer
